<template>
  <header class="header">
    <app-creation-modal
      v-if="canCreateEstableshiment"
      :data-activator-text="
        $t('message.admEstablishments.message.registerEstablishment')
      "
      data-entity="establishments"
    ></app-creation-modal>

    <div class="actions-wrapper">
      <p class="header-aps" v-if="isPartnerPage">Aparelhos: {{ apsCount }}</p>
      <i
        class="mdi mdi-file-download-outline"
        v-tooltip.auto="'Relatório de último acesso dos aparelhos'"
        @click="downloadAPsLastAccessReport"
      ></i>
      <app-search-bar v-model="search" @enter="emitLoadData"></app-search-bar>
    </div>
  </header>
</template>

<script>
import AppSearchBar from "@components/Search";
import AppCreationModal from "@components/user-modal/UserModal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppSearchBar,
    AppCreationModal,
  },

  data() {
    return {
      apsCount: 0,
    };
  },

  mounted() {
    if (this.isPartnerPage) {
      this.loadApCount();
    }
  },

  computed: {
    filterSearch() {
      return this.$store.state.establishments.filters.search;
    },
    canCreateEstableshiment() {
      return this.isAdmin || this.permissions.includes("CREATE_ESTABLISHMENT");
    },
    permissions() {
      return this.$store.state.users.user.permissions;
    },
    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
    isPartnerPage() {
      return location.pathname === "/estabelecimentos";
    },
  },

  methods: {
    search(value) {
      this.$store.commit("ESTABLISHMENTS_SET_FILTER", {
        key: "search",
        value: value,
      });
      return value;
    },
    emitLoadData() {
      EventBus.$emit("LOAD_DATA", this.search);
    },
    async loadApCount() {
      const apsCount = await this.$api.core.account.countAps();

      this.apsCount = apsCount;
    },
    async downloadAPsLastAccessReport() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const xlsFile =
          await this.$api.core.accessPoint.report.getLastAccessReport();

        const link = this.createElement(xlsFile);

        link.click();
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    createElement(xlsFile) {
      const url = window.URL.createObjectURL(new Blob([xlsFile]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "Excel-Relatorio-Aparelhos.xls");
      document.body.appendChild(link);

      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .actions-wrapper {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-right: 50px;

    .header-aps {
      font-weight: 600;
      margin-bottom: 0;
      padding-top: 12px;
    }

    .mdi {
      font-size: 28px;
      color: $grey-6;
      cursor: pointer;
      padding-top: 12px;
    }
  }
}
</style>
